import { runInInjectionContext, Injector } from '@angular/core';
import { FullNamePipe } from '@shared/pipes/fullname.pipe';
import { WcgMenuOption } from '@wcg/frontend-framework';
import { SMEQCUser } from '../types';

export function mapSmeQcUserToMenuOption(
  user: SMEQCUser,
  injector: Injector,
): WcgMenuOption {
  return runInInjectionContext(injector, () => {
    const fullNamePipe = injector.get(FullNamePipe);
    return {
      id: user.id,
      value: user.id,
      label: fullNamePipe.transform(user, 'lastFirst'),
    };
  });
}
